function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import s from "../common/base-provider.js";
import { newInAppMessageFromJson as ut } from "../InAppMessage/in-app-message-factory.js";
import ve from "../models/braze-event.js";
import { isArray as w, isEqual as ii, validateValueIsFromEnum as ta } from "../util/code-utils.js";
import { STORAGE_KEYS as t } from "../managers/storage-manager.js";
import wt from "../InAppMessage/models/templated-in-app-message.js";
import pt from "./models/trigger.js";
import et from "./models/trigger-events.js";
import { logger as N } from "../../shared-lib/index.js";

var gr = /*#__PURE__*/function (_s) {
  _inherits(gr, _s);

  var _super = _createSuper(gr);

  function gr(t, i, s, e, r) {
    var _this;

    _classCallCheck(this, gr);

    _this = _super.call(this), _this.tg = t, _this.Ms = i, _this.C = s, _this.Ue = e, _this.ig = r, _this.tg = t, _this.Ms = i, _this.C = s, _this.Ue = e, _this.ig = r, _this.sg = [], _this.eg = [], _this.hg = null, _this.ng = {}, _this.og = {}, _this.triggers = [], _this.lg = 0, _this.ag(), _this.gg();
    return _this;
  }

  _createClass(gr, [{
    key: "fg",
    value: function fg() {
      if (this.C) {
        this.hg = this.C.ps(t.bs.aE) || this.hg, this.ng = this.C.ps(t.bs.iE) || this.ng, this.og = this.C.ps(t.bs.nE) || this.og;

        for (var _t = 0; _t < this.triggers.length; _t++) {
          var i = this.triggers[_t];
          i.id && null != this.og[i.id] && i.ad(this.og[i.id]);
        }
      }
    }
  }, {
    key: "ag",
    value: function ag() {
      if (!this.C) return;
      this.lg = this.C.ps(t.bs.oE) || 0;
      var i = this.C.ps(t.bs.rE) || [],
          s = [];

      for (var _t2 = 0; _t2 < i.length; _t2++) {
        s.push(pt.Qn(i[_t2]));
      }

      this.triggers = s, this.fg();
    }
  }, {
    key: "gg",
    value: function gg() {
      var i = this,
          s = function s(t, _s2, e, r, h) {
        return function () {
          i.cg(t, _s2, e, r, h);
        };
      },
          e = {};

      var _iterator = _createForOfIteratorHelper(this.triggers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t7 = _step.value;
          _t7.id && (e[_t7.id] = _t7);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var r = !1;

      for (var _t3 = 0; _t3 < this.triggers.length; _t3++) {
        var _i = this.triggers[_t3];

        if (_i.id && null != this.ng[_i.id]) {
          var _t4 = this.ng[_i.id],
              h = [];

          for (var _r = 0; _r < _t4.length; _r++) {
            var n = _t4[_r],
                o = _i.ud(n.pn || 0);

            if (o > 0) {
              var _t5 = void 0,
                  _r2 = void 0;

              h.push(n), null != n.ug && (_t5 = n.ug), null != n.dg && ve.AE(n.dg) && (_r2 = ve.Qn(n.dg));
              var l = [];
              if (n.pg && w(n.pg)) for (var _t6 = 0; _t6 < n.pg.length; _t6++) {
                var _i2 = e[n.pg[_t6]];
                null != _i2 && l.push(_i2);
              }
              this.eg.push(window.setTimeout(s(_i, n.pn || 0, _t5, _r2, l), o));
            }
          }

          this.ng[_i.id].length > h.length && (this.ng[_i.id] = h, r = !0, 0 === this.ng[_i.id].length && delete this.ng[_i.id]);
        }
      }

      r && this.C && this.C.js(t.bs.iE, this.ng);
    }
  }, {
    key: "mg",
    value: function mg() {
      if (!this.C) return;
      var i = [];

      for (var _t8 = 0; _t8 < this.triggers.length; _t8++) {
        i.push(this.triggers[_t8].Bs());
      }

      this.lg = new Date().valueOf(), this.C.js(t.bs.rE, i), this.C.js(t.bs.oE, this.lg);
    }
  }, {
    key: "bg",
    value: function bg() {
      if (!this.C) return;
      (this.C.ps(t.bs.oE) || 0) > this.lg ? this.ag() : this.fg();
    }
  }, {
    key: "U",
    value: function U(i) {
      var s = !1;

      if (null != i && i.triggers) {
        this.ig.vn(), this.fg();
        var e = {},
            r = {};
        this.triggers = [];

        for (var _t9 = 0; _t9 < i.triggers.length; _t9++) {
          var _h = pt.fromJson(i.triggers[_t9]);

          if (_h) {
            _h.id && null != this.og[_h.id] && (_h.ad(this.og[_h.id]), e[_h.id] = this.og[_h.id]), _h.id && null != this.ng[_h.id] && (r[_h.id] = this.ng[_h.id]);

            for (var _t10 = 0; _t10 < _h.sd.length; _t10++) {
              if (_h.sd[_t10].kc(et.Xt, null)) {
                s = !0;
                break;
              }
            }

            this.triggers.push(_h);
          }
        }

        ii(this.og, e) || (this.og = e, this.C && this.C.js(t.bs.nE, this.og)), ii(this.ng, r) || (this.ng = r, this.C && this.C.js(t.bs.iE, this.ng)), this.mg(), s && (N.info("Trigger with test condition found, firing test."), this.ue(et.Xt)), this.ue(et.OPEN);
        var h = this.sg;
        var n;
        this.sg = [];

        for (var _t11 = 0; _t11 < h.length; _t11++) {
          n = Array.prototype.slice.call(h[_t11]), this.ue.apply(this, _toConsumableArray(n));
        }
      }
    }
  }, {
    key: "cg",
    value: function cg(t, i, s, e, r) {
      var _this2 = this;

      var h = function h(e) {
        _this2.fg();

        var r = new Date().valueOf();
        t.dd(i) || (!1 === navigator.onLine && t.type === pt.ln.an && e.imageUrl ? N.info("Not showing ".concat(t.type, " trigger action ").concat(t.id, " due to offline state.")) : t.nd(r) && _this2.wg(t, r, s) ? 0 === _this2.Ms.ic() ? N.info("Not displaying trigger ".concat(t.id, " because neither automaticallyShowInAppMessages() nor subscribeToInAppMessage() were called.")) : (_this2.Ms.X([e]), _this2.yg(t, r)) : N.info("Not displaying trigger ".concat(t.id, " because display time fell outside of the acceptable time window.")));
      },
          n = function n() {
        _this2.fg();

        var h = r.pop();
        if (null != h) if (_this2.Tg(h, i, s, e, r), h.dd(i)) {
          var _t12 = "Server aborted in-app message display, but the timeout on fallback trigger ".concat(h.id, " has already elapsed.");

          r.length > 0 && (_t12 += " Continuing to fall back."), N.info(_t12), n();
        } else {
          N.info("Server aborted in-app message display. Falling back to lower priority ".concat(h.type, " trigger action ").concat(t.id, "."));

          var _n = 1e3 * h.ed - (new Date().valueOf() - i);

          _n > 0 ? _this2.eg.push(window.setTimeout(function () {
            _this2.cg(h, i, s, e, r);
          }, _n)) : _this2.cg(h, i, s, e, r);
        }
      };

      var o, l, a;

      switch (t.type) {
        case pt.ln.an:
          if (o = ut(t.data), null == o) {
            N.error("Could not parse trigger data for trigger ".concat(t.id, ", ignoring."));
            break;
          }

          if (l = this.ig.Lr(o), l) {
            N.error(l), n();
            break;
          }

          h(o);
          break;

        case pt.ln.md:
          if (a = wt.fromJson(t.data, h, n, i, t.mn || 0), null == a) {
            N.error("Could not parse trigger data for trigger ".concat(t.id, ", ignoring."));
            break;
          }

          this.ig.Wr(a, s, e);
          break;

        default:
          N.error("Trigger ".concat(t.id, " was of unexpected type ").concat(t.type, ", ignoring."));
      }
    }
  }, {
    key: "ue",
    value: function ue(t) {
      var _this3 = this;

      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var s = arguments.length > 2 ? arguments[2] : undefined;
      if (!ta(et, t, "Cannot fire trigger action.", "TriggerEvents")) return;
      if (this.Ue && this.Ue.uc()) return N.info("Trigger sync is currently in progress, awaiting sync completion before firing trigger event."), void this.sg.push(arguments);
      this.bg();
      var e = new Date().valueOf(),
          r = e - (this.hg || 0);
      var h = !0,
          n = !0;
      var o = [];

      for (var _s3 = 0; _s3 < this.triggers.length; _s3++) {
        var _r3 = this.triggers[_s3],
            _l = e + 1e3 * _r3.ed;

        if (_r3.nd(_l) && (null == _r3.startTime || _r3.startTime.valueOf() <= e) && (null == _r3.endTime || _r3.endTime.valueOf() >= e)) {
          var _s4 = !1;

          for (var _e = 0; _e < _r3.sd.length; _e++) {
            if (_r3.sd[_e].kc(t, i)) {
              _s4 = !0;
              break;
            }
          }

          _s4 && (h = !1, this.wg(_r3, _l, t) && (n = !1, o.push(_r3)));
        }
      }

      if (h) return void N.info("Trigger event ".concat(t, " did not match any trigger conditions."));
      if (n) return void N.info("Ignoring ".concat(t, " trigger event because a trigger was displayed ").concat(r / 1e3, "s ago."));
      o.sort(function (t, i) {
        return t.priority - i.priority;
      });
      var l = o.pop();
      null != l && (N.info("Firing ".concat(l.type, " trigger action ").concat(l.id, " from trigger event ").concat(t, ".")), this.Tg(l, e, t, s, o), 0 === l.ed ? this.cg(l, e, t, s, o) : this.eg.push(window.setTimeout(function () {
        _this3.cg(l, e, t, s, o);
      }, 1e3 * l.ed)));
    }
  }, {
    key: "changeUser",
    value: function changeUser() {
      var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;

      if (this.triggers = [], this.C && this.C.Ls(t.bs.rE), !i) {
        this.sg = [], this.hg = null, this.og = {}, this.ng = {};

        for (var _t13 = 0; _t13 < this.eg.length; _t13++) {
          clearTimeout(this.eg[_t13]);
        }

        this.eg = [], this.C && (this.C.Ls(t.bs.aE), this.C.Ls(t.bs.nE), this.C.Ls(t.bs.iE));
      }
    }
  }, {
    key: "clearData",
    value: function clearData() {
      this.triggers = [], this.hg = null, this.og = {}, this.ng = {};

      for (var _t14 = 0; _t14 < this.eg.length; _t14++) {
        clearTimeout(this.eg[_t14]);
      }

      this.eg = [];
    }
  }, {
    key: "wg",
    value: function wg(t, i, s) {
      if (null == this.hg) return !0;
      if (s === et.Xt) return N.info("Ignoring minimum interval between trigger because it is a test type."), !0;
      var e = t.hd;
      return null == e && (e = this.tg), i - this.hg >= 1e3 * e;
    }
  }, {
    key: "Tg",
    value: function Tg(i, s, e, r, h) {
      this.fg(), i.id && (this.ng[i.id] = this.ng[i.id] || []);
      var n = {};
      var o;
      n.pn = s, n.ug = e, null != r && (o = r.Bs()), n.dg = o;
      var l = [];

      var _iterator2 = _createForOfIteratorHelper(h),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t15 = _step2.value;
          _t15.id && l.push(_t15.id);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      n.pg = l, i.id && this.ng[i.id].push(n), this.C && this.C.js(t.bs.iE, this.ng);
    }
  }, {
    key: "yg",
    value: function yg(i, s) {
      this.fg(), i.ad(s), this.hg = s, i.id && (this.og[i.id] = s), this.C && (this.C.js(t.bs.aE, s), this.C.js(t.bs.nE, this.og));
    }
  }]);

  return gr;
}(s);

export { gr as default };